import logo from './logo.svg';
import './App.css';
import { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import i18n from './i18n/config';

function App() {
  const [country, setCountry] = useState('');
  const { t } = useTranslation();
  const languages = ['en', 'ru', 'es', 'it', 'cs', 'de', 'pl', 'ro'];

  // Список кодов стран СНГ
  const cisCountries = ['RU', 'BY', 'KZ', 'KG', 'TJ', 'UZ', 'TM', 'AM', 'AZ', 'UA'];

  useEffect(() => {
    const fetchCountryData = async () => {
      try {
        const response = await fetch('https://get.geojs.io/v1/ip/geo.json');
        const data = await response.json();
        const countryCode = data.country_code;
        setCountry(countryCode);

        // Определяем язык сайта
        if (languages.includes(countryCode.toLowerCase())) {
          i18n.changeLanguage(countryCode.toLowerCase());
        } else if (cisCountries.includes(countryCode)) {
          i18n.changeLanguage('ru'); 
        } else {
          i18n.changeLanguage('en'); 
        }
      } catch (err) {
        console.error('Error fetching country data:', err);
      }
    };

    fetchCountryData();
  }, [i18n]);

  return (
    <div className="App">
      <header className="App-header">
        <div className='block'>
          <span className='icon'>
            <svg xmlns="http://www.w3.org/2000/svg" width={46} height={46} viewBox="0 0 24 24" fill="none">
              <path opacity="0.5" d="M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" fill="#00B4A0" />
              <path d="M16.0303 8.96967C16.3232 9.26256 16.3232 9.73744 16.0303 10.0303L11.0303 15.0303C10.7374 15.3232 10.2626 15.3232 9.96967 15.0303L7.96967 13.0303C7.67678 12.7374 7.67678 12.2626 7.96967 11.9697C8.26256 11.6768 8.73744 11.6768 9.03033 11.9697L10.5 13.4393L12.7348 11.2045L14.9697 8.96967C15.2626 8.67678 15.7374 8.67678 16.0303 8.96967Z" fill="#00B4A0" />
            </svg>
          </span>
          <div>
            <h2>{t('thank_you_for_registering')}</h2>
            <p>{t('manager_will_contact_you_soon')}</p>
          </div>
        </div>
      </header>
    </div>
  );
}

export default App;
